import {useId, forwardRef} from 'react'

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string
  labelClassName?: string
  labelStyle?: React.CSSProperties
  error?: string
  inputRef?: React.Ref<HTMLInputElement>
}

const Input = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const {
    type = 'text',
    label,
    labelClassName = '',
    labelStyle = {},
    error,
    autoComplete,
    required,
    className,
    style,
    inputRef,
    ...rest
  } = props
  const id = useId()

  return (
    <div className='w-100'>
      {label && (
        <label
          className={`form-label fw-semibold text-dark fs-6 ${labelClassName} ${
            required && 'required'
          }`}
          style={{
            ...labelStyle,
          }}
        >
          {label}
        </label>
      )}

      <input
        id={id}
        type={type}
        autoComplete={autoComplete ?? 'off'}
        className={`form-control ${error && 'is-invalid'} ${className}`}
        style={{
          ...style,
        }}
        ref={inputRef || ref}
        {...rest}
      />

      {error && (
        <div className='fv-plugins-message-container'>
          <div className='fv-help-block'>
            <span role='alert'>{error}</span>
          </div>
        </div>
      )}
    </div>
  )
})

export default Input
